module.exports = __webpack_public_path__ + "85dd4a4ab4cfa2410b806955bcf17b0d.png";